/***
*
*   DASHBOARD
*   Overview of your application usage
*
**********/

import { Card, Chart, Grid, Stat, Animate, useAPI } from 'components/lib';

export function Dashboard(props) {

  const stats = useAPI('/api/metrics/workspaces');
  const growth = useAPI('/api/metrics/accounts/growth');

  return (
    <Animate type='pop'>

      <Grid cols='3'>
        <Stat
          loading={stats?.loading}
          value={stats?.data?.totalWorkspaces}
          label='Workspaces'
          icon='users'
        />
        <Stat
          loading={stats?.loading}
          value={stats?.data?.activeWorkspaces}
          label='Active'
          icon='check'
        />
        <Stat
          loading={stats?.loading}
          value={stats?.data?.churnedWorkspaces}
          label='Churned'
          icon='arrow-down-right'
        />
      </Grid>

      <Card title='User Growth'>
        <Chart
          type='line'
          color='green'
          data={growth.data}
          loading={growth.loading}
        />
      </Card>
    </Animate>
  );
}
